/**
 * API Configuration
 * Central configuration for all API endpoints
 */

export const API_CONFIG = {
  // Base URL for API requests
  // Set REACT_APP_API_BASE_URL to override, or use deployed backend by default
  // To use localhost in development, set: REACT_APP_API_BASE_URL=/api/v1
  BASE_URL: process.env.REACT_APP_API_BASE_URL || 'https://capi-backend.bigatom.ai/api/v1',
  
  // Request timeout in milliseconds
  TIMEOUT: 30000,
  
  // Default orgId fallback if user profile missing one
  DEFAULT_ORG_ID: null,
};

// API Endpoints
export const API_ENDPOINTS = {
  METRICS: (orgId) => `/meta/quality/metrics/${orgId}`,
  PIXELS: (orgId) => `/meta/quality/latest-pixels/${orgId}`,
  PIXEL_EVENTS: (orgId, pixelId) => `/meta/quality/latest-pixel-events/${orgId}/${pixelId}`,
  OEMQ_SCORES: (orgId, datasetId) => `/meta/quality/oemq-scores?orgId=${encodeURIComponent(orgId)}&datasetId=${encodeURIComponent(datasetId)}`,
  REFRESH_DATASETS: (orgId) => `/meta/datasets/refresh?orgId=${encodeURIComponent(orgId)}`,
  META_OAUTH_START: (orgId) => `/meta/oauth/start?orgId=${encodeURIComponent(orgId)}`,
  META_OAUTH_CALLBACK: (code, state) =>
    `/meta/oauth/callback?code=${encodeURIComponent(code)}&state=${encodeURIComponent(state)}`,
  META_OAUTH_STATUS: (orgId) => `/meta/oauth/status?orgId=${encodeURIComponent(orgId)}`,
  META_OAUTH_DISCONNECT: (orgId) => `/meta/oauth/connection?orgId=${encodeURIComponent(orgId)}`,
  META_OAUTH_ORG_STATUSES: '/meta/oauth/org-statuses',
  DATASETS_LAST_UPDATED: (orgId) => `/meta/datasets/last-updated?orgId=${encodeURIComponent(orgId)}`,
  ALERT_PREFERENCES: (orgId) => `/admin/alerts/preferences/${orgId}`,
  ALERT_EMAILS: (orgId) => `/admin/alerts/emails/${orgId}`,
  UPDATE_ALERT_EMAILS: (orgId) => `/admin/alerts/emails/${orgId}`,
  UPDATE_ALERT_PREFERENCES: (orgId) => `/admin/alerts/preferences/${orgId}`,
  
  // Authentication endpoints
  SIGNUP: '/auth/signup',
  LOGIN: '/auth/login',
  
  // Email endpoints
  SEND_EMAIL: '/mail/send',
};

// Log the configuration for debugging
console.log('🔧 API Configuration Loaded:');
const sampleOrgId = API_CONFIG.DEFAULT_ORG_ID ?? '{orgId}';
const sampleMetricsUrl =
  API_CONFIG.DEFAULT_ORG_ID !== null && API_CONFIG.DEFAULT_ORG_ID !== undefined
    ? `${API_CONFIG.BASE_URL}${API_ENDPOINTS.METRICS(sampleOrgId)}`
    : `${API_CONFIG.BASE_URL}/meta/quality/metrics/{orgId}`;
console.log('   Base URL:', API_CONFIG.BASE_URL);
console.log('   Default Org ID:', API_CONFIG.DEFAULT_ORG_ID ?? 'not set');
console.log('   Timeout:', API_CONFIG.TIMEOUT, 'ms');
console.log('   Sample Metrics URL:', sampleMetricsUrl);
console.log('');
console.log('📍 Expected Flow:');
console.log('   1. Frontend calls:', sampleMetricsUrl);
console.log('   2. Backend should serve:', sampleMetricsUrl);
console.log('   Note: Configure a dev proxy if using relative paths.');
console.log(' ');